module.exports = __webpack_public_path__ + "static/img/JonRalph.df57056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JonRalph.jpg
// module id = qyd9
// module chunks = 0